var _defs, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg101(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 65.42 43.71",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".g{fill:#00322e;}.h{fill:#fff;filter:url(#b);}.i{filter:url(#e);}"), /*#__PURE__*/React.createElement("filter", {
    id: "b",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 0
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "c",
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#000",
    floodOpacity: 0.18
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "c",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "e",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 0
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "f",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#000",
    floodOpacity: 0.15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "f",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M43.09,5.19c-6.59,0-11.64,3.29-14.39,8.89l1.45-8.21h-12.4l-.47,1.34c-.86,2.44-2.18,3.18-5.66,3.18l-1.93-.02-2.09,11.94,2.04,.29c.39,.06,1.16,.1,1.56,.1,1,0,1.91-.08,2.75-.26l-2.56,14.81h13.21l1.88-10.65c.63,7.13,5.34,11.33,12.88,11.33,9.95,0,16.64-7.84,16.64-19.52,0-8.29-4.83-13.24-12.92-13.24Zm-2.36,21.41c-.21,.48-.34,.59-.34,.59,0,0-.09,.04-.34,.04-.03,0-.05,0-.07,0-.04-.11-.09-.34-.09-.76,0-2.03,.73-7.49,1.75-9.91,.29-.65,.48-.65,.65-.65,.06,0,.11,0,.15,0,.04,.14,.09,.42,.09,.91,0,2.1-.88,7.7-1.8,9.77Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "d"
  }, /*#__PURE__*/React.createElement("g", {
    className: "i"
  }, /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M27.77,7.87l-4.84,27.4H13.77l2.8-16.2c-1.32,1.16-3.08,1.64-5.36,1.64-.32,0-1-.04-1.28-.08l1.44-8.24c4.12,.04,6.52-.88,7.8-4.52h8.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M28.41,24.95c0-10.16,5.08-17.76,14.68-17.76,7.32,0,10.92,4.48,10.92,11.24,0,9.76-5.28,17.52-14.64,17.52-6.96,0-10.96-3.84-10.96-11Zm14.16,2.44c1.08-2.44,1.96-8.36,1.96-10.56s-.88-2.92-2.24-2.92c-1,0-1.88,.48-2.48,1.84-1.2,2.84-1.92,8.6-1.92,10.72,0,1.88,.76,2.76,2.16,2.76,1.2,0,1.92-.44,2.52-1.84Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg101);
export default __webpack_public_path__ + "static/media/10_1.97c7575207bf7dd6f58ab61620a478fd.svg";
export { ForwardRef as ReactComponent };